import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

interface T { id: string; name: string; slug: string; category: string; status: string; version: number }

export function VideoTemplatesPage() {
  const [templates, setTemplates] = useState<T[]>([]);
  const [msg, setMsg] = useState<string | null>(null);
  const load = useCallback(async () => { try { setTemplates(await api.videoTemplatesPanel.list()); } catch { /* noop */ } }, []);
  useEffect(() => { load().catch(() => undefined); }, [load]);
  const clone = async (t: T) => {
    try { await api.videoTemplatesPanel.clone(t.id, `${t.name} (kopia)`); setMsg(`Skopiowano: ${t.name}`); await load(); }
    catch (e) { setMsg((e as Error).message); }
  };
  return (
    <div>
      <h2>Video Templates</h2>
      <p className="muted">Starterowe szablony renderu (Remotion).</p>
      {msg && <div className="alert" style={{ marginBottom: 12 }}>{msg}</div>}
      <div className="card">
        <div className="card__header">Szablony ({templates.length})</div>
        <table>
          <thead><tr><th>Nazwa</th><th>Slug</th><th>Kategoria</th><th>Status</th><th>Wersja</th><th /></tr></thead>
          <tbody>
            {templates.map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td><td className="mono" style={{ fontSize: 12 }}>{t.slug}</td>
                <td>{t.category}</td><td>{t.status}</td><td>{t.version}</td>
                <td><button className="btn btn--sm" onClick={() => clone(t)}>Klonuj</button></td>
              </tr>
            ))}
            {templates.length === 0 && <tr><td colSpan={6} className="muted">Brak szablonów.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
